var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MyTable',{staticStyle:{"margin":"1rem"},attrs:{"tableData":_vm.tableData,"table_label":_vm.table_label,"name":_vm.name,"total":_vm.total,"page":_vm.data.page},on:{"Currentchange":_vm.contractlistcontractlist}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }